import http from '@/utils/http';
const base_path = '/v2/tool/materialLabel';

/**
 * 获取渠道素材标签列表
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getMaterialLabelListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 获取渠道素材标签选择器
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getMaterialLabelSelectorApi = (params) => {
  return http.get({
    url: `${base_path}/selector`,
    params,
  });
};

/**
 * 新增渠道素材标签
 * @param {Object} data 请求数据
 * @returns {Promise<Object>}
 */
export const addMaterialLabelApi = (data) => {
  return http.post({
    url: base_path,
    data,
  });
};

/**
 * 删除渠道素材标签
 * @param {string} id ID
 * @param {Object} data 请求数据
 * @returns {Promise<Object>}
 */
export const delMaterialLabelApi = (id, data) => {
  return http.delete({
    url: `${base_path}/${id}`,
    data,
  });
};

/**
 * 绑定渠道素材标签
 * @param {Object} data 请求数据
 * @returns {Promise<Object>}
 */
export const bindMaterialLabelApi = (data) => {
  return http.post({
    url: `${base_path}/bind`,
    data,
  });
};

/**
 * 解绑渠道素材标签
 * @param {Object} data 请求数据
 * @returns {Promise<Object>}
 */
export const unbindMaterialLabelApi = (data) => {
  return http.post({
    url: `${base_path}/unbind`,
    data,
  });
};

/**
 * 获取标签绑定素材
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getMaterialByLabelApi = (id, params) => {
  return http.get({
    url: `${base_path}/${id}/materials`,
    params,
  });
};
